import { render } from "./TheChart.vue?vue&type=template&id=728545ce"
import script from "./TheChart.vue?vue&type=script&lang=js"
export * from "./TheChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__